// FE Routes
export const ROOT_PATH = "/" as const;
export const TOP_PATH = "/cdc/top" as const;
export const PACKAGE_LIST_PATH = "/cdc/packages" as const;
export const PACKAGE_DETAIL_PATH = "/cdc/packages/[packageId]" as const;
export const PACKAGE_ALREADY_PURCHASED_PATH =
  "/cdc/packages/already-purchased" as const;
export const PURCHASE_LIST_PATH = "/cdc/orders" as const;
export const VEHICLES_LIST_PATH = "/cdc/vehicles" as const;
export const CANCEL_CONFIRM_PATH = "/cdc/cancel-confirm" as const;
export const CANCEL_FINISH_PATH = "/cdc/cancel-finish" as const;
export const ORDER_CONFIRM_PATH = "/cdc/order-confirm" as const;
export const ORDER_FINISH_PATH = "/cdc/order-finish" as const;
export const OWNER_AUTH_PATH = "/cdc/owner-auth" as const;
export const OWNER_VERIFICATION_PATH = "/cdc/owner-verification" as const;
export const LOGIN_PATH = "/login" as const;
export const LOGIN_OPTIONS_PATH = "/login-options" as const;
export const FAQ_PATH = "/faq" as const;
export const REDIRECT_PATH = "/redirect" as const;

// BE API Routes
export const GET_TERMS_API_URI = "/api/terms" as const;
export const GET_CANCEL_POLICY_API_URI = "/api/cancel-policy" as const;
export const POST_ORDER_API_URI = "/api/orders" as const;
export const GET_ORDERS_API_URI = "/api/orders" as const;
export const POST_ORDER_CANCEL_API_URI = "/api/orders/cancellation" as const;

export const GET_TOP_API_URI = "/api/top" as const;
export const REFRESH_TOKEN_API_URI = "/api/token" as const;
export const GET_PACKAGE_DETAIL_API_URI = "/api/packages/[packageId]" as const;
export const GET_PACKAGE_LIST_API_URI = "/api/packages" as const;
export const GET_PACKAGE_ORDERS_API_URI = "/api/packages/orders" as const;
export const ROLE_VERIFY_API_URI = "/api/users/info" as const;
export const GET_OWNER_VERIFY_API_URI = "/api/users/owner-verify" as const;
export const POST_VERIFY_OWNER_API_URI = "/api/users/verify-owner" as const;
export const GET_OWNER_VERIFICATION_API_URI = "/api/owner-verification" as const;

// Pagination default
export const TOP_LIMIT = 6 as const;
export const PACKAGE_LIST_PAGE_SIZE = 10 as const;
export const PURCHASE_LIST_PAGE_SIZE = 10 as const;

// Default time interval
export const DEFAULT_GC_TIME_MS = 10 * 60 * 1000;
export const DEFAULT_STALE_TIME_MS = 10 * 60 * 1000;
export const DEFAULT_POLLING_INTERVAL_MS = 20 * 1000;
export const DEFAULT_POLLING_TIMEOUT_MS = 10 * 60 * 1000;
export const CDC_OWNER_AUTH_INITIAL_DELAY_MS = 5_000;
export const CDC_OWNER_AUTH_POLL_INTERVAL_MS = 60 * 1000;
export const CDC_OWNER_AUTH_TIMEOUT_MS = 5 * 60 * 1000;

// Error related constants
export const UNEXPECTED_ERROR_CODE = "UNEXPECTED_ERROR" as const;
// 冪等キー付き POST の結果未確定コード（BE で処理済みの可能性があるため、同じキーで再送させる）
// 同一キーの先行リクエストが処理中（BE 409）
export const REQUEST_IN_PROGRESS_CODE = "REQUEST_IN_PROGRESS" as const;
// 5xx・タイムアウト・通信断で処理結果を確認できない
export const RESULT_UNKNOWN_CODE = "RESULT_UNKNOWN" as const;

// Idempotency-Key（業務操作単位の冪等キー）
export const IDEMPOTENCY_KEY_HEADER = "Idempotency-Key" as const;
export const IDEMPOTENCY_KEY_TTL_MS = 30 * 60 * 1000;
export const REQUEST_IN_PROGRESS_MAX_RETRY = 3;
export const REQUEST_IN_PROGRESS_RETRY_DELAY_MS = 2_000;
